import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Container } from "react-bootstrap";
import { loadProfessor } from "../../lib/api/professor";
import { ProfessorDetailForm } from "../../components/professor/ProfessorDetailForm";
import { EmptyBlank, ModalAuthCode } from "../../components/common";

const Detail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [professor, setProfessor] = useState();
  const [auth, setAuth] = useState({
    code: undefined,
    beginDate: undefined,
    endDate: undefined,
    show: false,
  });

  const requestLoadProfessor = useCallback(async () => {
    const { data } = await loadProfessor({ id: id });
    //console.log(data);
    setProfessor(data);
  }, [id]);

  useEffect(() => {
    requestLoadProfessor();
  }, [requestLoadProfessor]);

  const handelEdit = (e) => {
    const userId = id;
    navigate(`/professors/${userId}/edit`);
  };

  const handelAssessment = (e) => {
    const weekId = e.target.value;
    navigate(`../../assessments/${weekId}`);
  };

  // auth 값을 바로 가져오기 위해서 인자가 auth입니다.
  const handelAuth = (auth) => {
    console.log("auth => ", auth);
    setAuth((cur) => {
      return { ...auth, show: true };
    });
  };

  const handleCloseModalAuthCode = (e) => {
    setAuth((cur) => {
      return { ...cur, show: false };
    });
  };

  return (
    <div>
      <Container fluid="md">
        {professor ? (
          <ProfessorDetailForm
            professor={professor}
            handelAuth={handelAuth}
            handelEdit={handelEdit}
            handelAssessment={handelAssessment}
          />
        ) : undefined}
        <EmptyBlank />
        <ModalAuthCode
          code={auth.code}
          beginDate={auth.beginDate}
          endDate={auth.endDate}
          show={auth.show}
          handleClose={handleCloseModalAuthCode}
        />
      </Container>
    </div>
  );
};

export default Detail;
